import {createProperty} from './utils/createProperty'

/**
 * The annotation builder for a component property with type 'boolean'.
 */
export const boolean = createProperty('boolean').typed('boolean')
